const navigation = (() => {
	const _o = {
		breakpoints: {
        mediumDownMax: 1023
    },
    prevScroll: window.pageYOffset,
    menuTrigger: document.querySelector('.menu-trigger'),
    menuEl: document.querySelector("[data-main-menu]"),
    body: document.querySelector("body")
  };

	const init = () => {
        if(_o.menuTrigger && window.innerWidth <= _o.breakpoints.mediumDownMax) {
            _o.menuTrigger.addEventListener("click", (e) => onClickMenuTrigger(e, _o.menuTrigger));
            window.addEventListener("resize", () => onResize());
        }

        window.addEventListener("scroll", () => onScroll());
	};

  const onClickMenuTrigger = (e, trigger) => {
    trigger.classList.toggle("active");
    _o.menuEl.classList.toggle("active");
    _o.body.classList.toggle("nav-opened");
  };

  const onResize = () => {
    _o.menuTrigger.classList.remove("active");
    _o.menuEl.classList.remove("active");
    _o.body.classList.remove("nav-opened");
  };

  const onScroll = () => {
    const currentScroll = window.pageYOffset;

    if (_o.prevScroll > currentScroll) {
      _o.body.classList.remove("scroll-down");
    } else {
      _o.body.classList.add("scroll-down");
    }

    _o.prevScroll = currentScroll;
  };

	return {
        init: init
    };
})();

export default navigation;
